import React from "react";
import { alpha, Theme } from "@mui/material";

type Props = {
  children: React.ReactNode;
  noPadding?: boolean;
  interactive?: boolean;
  theme?: Theme;
  style?: React.CSSProperties;
};

export const ChartTooltip = ({
  theme,
  children,
  noPadding = false,
  interactive = false,
  style,
}: Props) => {
  if (!theme) return null;

  return (
    <div
      style={{
        fontFamily: theme.typography.fontFamily,
        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.08)",
        padding: !noPadding ? theme.spacing(2) : 0,
        borderRadius: theme.shape.borderRadius * 1.25,
        backgroundColor: alpha(theme.palette.background.tooltipPrimary, 0.9),
        position: "relative",
        overflow: "hidden",
        pointerEvents: interactive ? "auto" : "none",
        width: "fit-content",
        minWidth: "fit-content",
        maxWidth: "none",
        display: "inline-block",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
